const chargerDetailsMap = {
  lastReportedAt: "Last Reported At",
  displayName: "Display Name",
  timezone: "Timezone",
  warrantyDueDate: "Warranty Due Date",
  isConnected: "Is Connected",
  wifiConfig: "WiFi Config",
  hoControl: "HO Control",
  activeConnection: "Active Connection",
  operatingVoltage: "Operating Voltage",
  dlbEnabled: "DLB Enabled",
  createdAt: "Created At",
  warrantyStartDate: "Warranty Start Date",
  warrantyPeriod: "Warranty Period (years)",
  sku: "SKU",
  firmwareVersion: "Firmware Version",
  serialNumber: "Serial Number",
  commissioningStatus: "Commissioning Status",
  phaseMode: "Phase Mode",
  modelName: "Model Name",
  ratedCurrent: "Rated Current",
  siteId: "Site ID",
  partNumber: "Part Number",
  isRetired: "Is Retired",
  status: "Status",
  phaseCount: "Phase Count",
};

export { chargerDetailsMap };
